module.exports = __webpack_public_path__ + "img/gb9113_10_b.prt.7290dc4f.jpg";